import c from "../common"
export default {
    // Dashboard
    Title: c.EstampPlan.chn,
    Create: "創建",
    PointExpiry: "積分到期",
    EarnPeriodTo: "賺取積分期至",
    EarnRate: "賺取1分",

    // Status
    Pending: c.Pending.chn,
    OnGoing: c.OnGoing.chn,
    ExpiredNCancelled: c.Expired.chn + " & " + c.Cancelled.chn,
    Cancelled: c.Cancelled.chn,
    Expired: c.Expired.chn,
    WaitApprove: c.WaitApprove.chn,
    
    // Common
    To: "至",
    NA: c.NA.chn,
    Back: c.Back.chn,
    Edit: "編輯",
    Previous: c.previous.chn,
    Submit: "提交",
    Complete: c.complete.chn,
    Next: c.next.chn,
    ConfirmBtn: c.Confirm.chn,

    // Detail
    Release: "電子券推出市場",
    VoucherExpire: "電子券到期",
    EarnStart: "開始賺取積分",
    EarnEnd: "結束賺取積分",
    EarnRule: "賺取積分規則",
    EarnRuleDetail1: "單筆購買電子劵滿$",
    EarnRuleDetail2: "賺取1分",
    EarnRedemtpion: "積分換領列表",
    Name: "名稱",
    RedemptionPeriod: "換領期限",
    PaymentMethod: "支付方式",
    Quota: "配額",
    Available: "餘下",
    RedeemCost: "需要",
    EarnRange: "賺取積分日期",
    Confirm: "提交前再次確認資料正確",
    CreateVoucher: "創建電子券",
    Add: c.add.chn,
    ChooseVoucher: "選擇劵",
    VoucherDetail: "詳情",
    Price: "售價: ",
    QuotaLim: "配額上限",
    ReqPoint: "所需積分",
    ReqMoney: "所需金錢",
    ChooseFromEvent: "請選擇現有活動",
    CostPoint: "{{point}} 積分",
    CostMoney: "{{point}} 積分 + ${{money}}",
    Point: "積分",
    PointMoney: "積分+錢",

    // Step
    Detail : "計劃詳情",
    List: "換領列表",
    Summary: "總結",

    // Message
    NoVoucher: "尚未有已審批電子券",
    Info1: "可分配上限為: 這批電子劵已發行量 減去 已賣出量",
    Info2: "預留用於積分換領的數量",
    Info3: "換領一張劵所需積分",
    Info4: "不可與已有期限重疊",
    Info5: "如要創建積分計劃, 必須有至少一個活動及已發行的電子劵",
    Info6: "不可選擇與現有積分計劃時間重疊的活動",
    Info7: "進行中的活動不可更改以下內容",
    Info8: "一經提交立即生效",
    Info9: "需要積分+錢換取一張電子劵",
    Warning1: "此劵在下列推廣活動進行中, 時段不可重疊",
    Warning2: "配額不可為0",
    Warning3: "所需積分不可為0",
    Warning4: "換領期限不可為空",
    Warning5: "請先創建活動",
    Warning6: "進行中和尚未推行的積分計劃總數上限為2",
    Warning7: "如更改活動將需重新填寫所有資料",
    Warning8: "請先完成表格！",
    Warning9: "請最少添加一種可兌換券",
    Warning10: "賺取積分時段不可與現有積分計劃重疊",
    Success1: "成功創建積分計劃",
    Success2: "成功修改",
}